export default function CTASection() {
  return (
    <section className="relative w-full py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20sand%20and%20terracotta%20abstract%20geometric%20shapes%20with%20flowing%20curves%2C%20minimalist%20elegant%20art%20composition%2C%20soft%20diffused%20golden%20lighting%2C%20contemporary%20design%20background%2C%20editorial%20quality%2C%20no%20text%20no%20people%2C%20warm%20natural%20palette&width=1800&height=800&seq=cta-bg-litbuy-v2&orientation=landscape"
          alt="Get started with Litbuy Spreadsheet"
          className="w-full h-full object-cover object-top"
          title="Litbuy Spreadsheet call to action"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50">
            Ready to Explore Litbuy Spreadsheet?
          </h2>
          <p className="mt-5 text-base md:text-lg text-background-50/75 max-w-lg mx-auto leading-relaxed">
            Visit the main website to discover the full range of tools, templates, and resources available to transform your workflow.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-3 rounded-full bg-background-50 px-8 py-4 text-sm font-semibold text-foreground-950 transition-all duration-300 cursor-pointer hover:bg-background-100 hover:scale-[1.02]"
            >
              Explore Main Website
              <span className="w-5 h-5 flex items-center justify-center rounded-full bg-foreground-950">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}